<button
  [matTooltip]="content"
  [matTooltipDisabled]="!collapsed"
  *ngIf="condition"
  [attr.aria-label]="aria"
  (click)="click()"
  [disabled]="disabled"
  class="btn cssFadeIn"
  [ngClass]="{
    'btn-small': small,
    'btn-warn': warn,
    'btn-outline': outline,
    'btn-clear': clear,
    'btn-outline-warn': outline && warn,
    'btn-active': active,
    'btn-chip': chip,
    'btn-collapsed': collapsed
  }"
>
  <ng-content></ng-content>
  <keycom-nav-icon *ngIf="icon && active" [color]="'white'" [iconName]="icon" class="unclickable"></keycom-nav-icon>
  <keycom-nav-icon *ngIf="icon && !active" [color]="'#393E46'" [iconName]="icon" class="unclickable"></keycom-nav-icon>
  <span
    *ngIf="content && !collapsed"
    class="content icon unclickable"
    [ngClass]="{
      'btn-content-icon': !chip,
      'btn-content-chip': chip
    }"
  >
    {{ content }}
  </span>
</button>
